(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kindra-local-project"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kindra-film-player')) {
    customElements.define('kindra-film-player', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('button')?.addEventListener('click', () => {
          const template = this.querySelector('template');
          if (!template) return;
          this.append(template.content.cloneNode(true));
          this.querySelector('button')?.remove();
          this.querySelector('iframe')?.focus();
        }, { once:true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kindra-site-planning"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kindra-site-planning')) {
  customElements.define('kindra-site-planning', class extends HTMLElement {
    connectedCallback() {
      const drawer = document.querySelector('.kindra-contact-drawer');
      const button = this.querySelector('[data-planning-contact]');
      if (drawer && button) button.setAttribute('aria-controls', drawer.id);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kindra-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kindra-testimonials')) {
    customElements.define('kindra-testimonials', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        const options = { signal: this._abort.signal };
        this._viewport = this.querySelector('[data-viewport]');
        this._reviews = Array.from(this.querySelectorAll('[data-review]'));
        this._counter = this.querySelector('[data-review-counter]');
        this._announcement = this.querySelector('[data-announcement]');
        this._index = 0;
        if (!this._viewport || !this._reviews.length) return;

        this._reviews.forEach((review, index) => {
          review.hidden = index !== 0;
          review.setAttribute('role', 'group');
          review.setAttribute('aria-roledescription', 'slide');
          review.setAttribute('aria-label', `${index + 1} of ${this._reviews.length}`);
        });
        this.setAttribute('data-enhanced', '');
        this._counter.hidden = this.dataset.counter !== 'true';
        this.querySelector('[data-controls]').hidden = this._reviews.length < 2 || this.dataset.navigation !== 'true';
        if (this._reviews.length > 1) this.setAttribute('tabindex', '0');
        this._counter.textContent = `1 / ${this._reviews.length}`;
        this._measure();

        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this._index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this._index + 1), options);
        this.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('a, input, textarea, select, [contenteditable="true"]')) return;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this._index + (event.key === 'ArrowRight' ? direction : -direction));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.show(event.key === 'Home' ? 0 : this._reviews.length - 1);
          }
        }, options);

        this._viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch' || !event.isPrimary || event.target.closest('a, button, input, textarea, select')) return;
          this._touch = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, options);
        this._viewport.addEventListener('pointercancel', () => { this._touch = null; }, options);
        this._viewport.addEventListener('pointerup', (event) => {
          const touch = this._touch;
          this._touch = null;
          if (!touch || touch.id !== event.pointerId) return;
          const x = event.clientX - touch.x;
          const y = event.clientY - touch.y;
          if (Math.abs(x) >= 50 && Math.abs(x) > Math.abs(y) * 1.5) {
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            this.show(this._index + (x < 0 ? direction : -direction));
          }
        }, options);

        this._resize = () => {
          cancelAnimationFrame(this._resizeFrame);
          this._resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected) this._measure();
          });
        };
        if ('ResizeObserver' in window) {
          this._observer = new ResizeObserver(this._resize);
          this._reviews.forEach(review => this._observer.observe(review));
        }
        window.addEventListener('resize', this._resize, options);
        if (document.fonts) {
          document.fonts.ready.then(() => {
            if (!options.signal.aborted && this.isConnected) this._resize();
          });
          document.fonts.addEventListener('loadingdone', this._resize, options);
        }

        document.addEventListener('shopify:block:select', (event) => {
          const index = this._reviews.findIndex(review => review.dataset.blockId === event.detail?.blockId);
          if (index >= 0 && this.contains(event.target)) this.show(index, { instant: true, announce: false });
        }, options);
      }

      _measure() {
        if (!this._reviews?.length) return;
        const height = Math.ceil(this._reviews[this._index].getBoundingClientRect().height);
        if (height < 1 || Math.abs(height - (this._targetHeight || 0)) < 1) return;
        this._heightAnimation?.cancel();
        this._heightAnimation = null;
        this._targetHeight = height;
        this._viewport.style.height = `${height}px`;
      }

      show(index, { instant = false, announce = true } = {}) {
        if (!this._reviews?.length) return;
        const nextIndex = ((index % this._reviews.length) + this._reviews.length) % this._reviews.length;
        if (nextIndex === this._index) {
          this._measure();
          return;
        }
        const previousHeight = this._viewport.getBoundingClientRect().height;
        this._heightAnimation?.cancel();
        this._fadeAnimation?.cancel();
        const previousReview = this._reviews[this._index];
        const nextReview = this._reviews[nextIndex];
        // If a source link has focus, move focus before removing that slide.
        if (previousReview.contains(document.activeElement)) this.focus({ preventScroll: true });
        previousReview.hidden = true;
        nextReview.hidden = false;
        this._index = nextIndex;
        const nextHeight = Math.ceil(nextReview.getBoundingClientRect().height);
        this._targetHeight = nextHeight;
        this._viewport.style.height = `${nextHeight}px`;
        this._counter.textContent = `${nextIndex + 1} / ${this._reviews.length}`;
        if (announce) this._announcement.textContent = `Review ${nextIndex + 1} of ${this._reviews.length}`;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!instant && !reduceMotion && typeof this._viewport.animate === 'function') {
          this._heightAnimation = this._viewport.animate(
            [{ height: `${previousHeight}px` }, { height: `${nextHeight}px` }],
            { duration: 280, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
          this._fadeAnimation = nextReview.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
        }
      }

      disconnectedCallback() {
        this._abort?.abort();
        this._abort = null;
        this._observer?.disconnect();
        this._heightAnimation?.cancel();
        this._fadeAnimation?.cancel();
        cancelAnimationFrame(this._resizeFrame);
        this._touch = null;
        this._targetHeight = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
